/**
 * Protected Route Component
 */
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/services/auth/authContext';
import { motion } from 'framer-motion';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();
  const isDemo = localStorage.getItem('isDemo') === 'true';
  
  console.log('[ProtectedRoute] Auth check:', {
    isAuthenticated,
    isLoading,
    isDemo,
    user,
    location: location.pathname
  });

  // Show loading spinner while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-[#1f4ed1] to-[#2256e5] flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-center"
        >
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-white border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" />
          <p className="mt-4 text-white text-lg">Loading...</p>
        </motion.div>
      </div>
    );
  }

  // Check if user is authenticated or is a demo user
  if (!isAuthenticated && !isDemo) {
    return <Navigate to="/restaurant-login" state={{ from: location }} replace />;
  }
  
  // For demo users who lost auth, redirect to demo login
  if (isDemo && !isAuthenticated) {
    return <Navigate to="/dancing-queen" state={{ from: location }} replace />;
  }

  // Render protected content
  return <>{children}</>;
};

export default ProtectedRoute;